import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuillModules } from 'ngx-quill';

import { UniversityService } from 'src/app/core/services/university/university.service';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';

@Component({
    selector: 'app-angila-form',
    templateUrl: './angila-form.component.html',
    styleUrls: ['./angila-form.component.scss'],
})
export class AngilaFormComponent implements OnInit {
    @Input() interviewForm: FormGroup | any;
    @Input() showOnlyTemplate: boolean = false;
    @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

    QuillModules: QuillModules = {
        toolbar: [
            // default value
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ['clean'], // remove formatting button
            ['link', 'image', 'video'], // link and image, video
        ],
    };

    radioQuestionArr: any = [
        {
            type: 'radio',
            labelName: 'Common Questions',
            categoryName: 'Common',
            isRequired: true,
            question: 'Is the student giving interview is same as in passport?',
            options: [
                {
                    id: 'passport_check1',
                    name: 'passport_check',
                    value: 1,
                    label: 'Yes',
                },
                {
                    id: 'passport_check2',
                    name: 'passport_check',
                    value: 0,
                    label: 'No',
                },
                {
                    id: 'passport_check3',
                    name: 'passport_check',
                    value: 2,
                    label: 'Doubtful',
                },
            ],
            subQuestions: [
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 2,
                    type: 'radio',
                    isRequired: true,
                    question: 'Please confirm your Date of Birth',
                    options: [
                        {
                            id: 'doubt_dob1',
                            name: 'doubt_dob',
                            value: 1,
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_dob2',
                            name: 'doubt_dob',
                            value: 0,
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 2,
                    type: 'radio',
                    isRequired: true,
                    question: 'Please tell me your place of birth',
                    options: [
                        {
                            id: 'doubt_dobplace1',
                            name: 'doubt_dobplace',
                            value: 1,
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_dobplace2',
                            name: 'doubt_dobplace',
                            value: 0,
                            label: 'Not Answered',
                        },
                    ],
                },
            ],
            subQuestionLabel: {
                label: 'Doubtful Questions',
                categoryName: 'Doubtful',
            },
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question:
                'The interview will take approximately 30 minutes. Are you feeling fit and well enough to be interviewed today?',
            options: [
                {
                    id: 'interview_ans1',
                    name: 'interview_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'interview_ans2',
                    name: 'interview_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question:
                'Can you hear me clearly and understand what I am saying?',
            options: [
                {
                    id: 'hear_me1',
                    name: 'interview_ans',
                    value: '1',
                    label: 'Answered',
                },
                {
                    id: 'hear_me2',
                    name: 'interview_ans',
                    value: '0',
                    label: 'Not Answered',
                },
            ],
        },
    ];

    decisionQuestionArr: any = [
        {
            primary: {
                heading: 'Decision',
                label: 'Decision Questions',
                categoryName: 'Decision',
            },
            questions: [
                {
                    type: 'radio',
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    isRequired: true,
                    question: 'Have you understood all the questions?',
                    options: [
                        {
                            id: 'all_ans1',
                            name: 'all_ans',
                            value:'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'all_ans2',
                            name: 'all_ans',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    type: 'radio',
                    isRequired: true,
                    question: 'Is there anything else you wish to add?',
                    options: [
                        {
                            id: 'anything_else1',
                            name: 'anything_else',
                            value: '1',
                            label: 'Answered',
                        },
                        {
                            id: 'anything_else2',
                            name: 'anything_else',
                            value: '0',
                            label: 'Not Answered',
                        },
                    ],
                },
            ],
        },
    ];

    interviewQuestions: any = [
        {
            primary: {
                heading: 'Interview Questions',
                label: 'Compulsory Questions',
                categoryName: 'Compulsory',
                decisions: [
                    {
                        value: 'Good',
                        label: 'Good',
                    },
                    {
                        value: 'Average',
                        label: 'Average',
                    },
                    {
                        value: 'Poor',
                        label: 'Poor',
                    },
                ],
            },
            riskScore: {
                question: 'Risk Score',
                answerType: 'text',
                labelName: 'Compulsory Questions',
                categoryName: 'Compulsory',
            },
            releventInformation: {
                question: 'Please add any other relevant information:',
                answerType: 'textarea',
                labelName: 'Relevant Questions',
                categoryName: 'Relevant',
            },
            casRecommended: {
                question: 'CAS Recommended',
                answerType: 'options',
                options: [
                    {
                        value: 'YES',
                        label: 'Yes',
                    },
                    {
                        value: 'NO',
                        label: 'NO',
                    },
                    {
                        value: 'REFERRED',
                        label: 'REFERRED',
                    },
                    {
                        value: 'YES But put on Risk Board',
                        label: 'YES But put on Risk Board',
                    },
                ],

                labelName: 'Compulsory Questions',
                categoryName: 'Compulsory',
            },
            questionList: [
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question: '1. Why did you choose to study this course?',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Compulsory Sub Questions',
                            questions:
                                'Are they able to answer why they chose to study in the UK?',
                            answerType: 'text',
                        },
                    ],
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '2.Which other institutions did you consider?3.Why did you choose this institution?',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Compulsory Questions',
                            questions:
                                'Are they able to list/discuss other institutions they considered and why they decided on ARU?',
                            answerType: 'text',
                        },
                    ],
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '4. How are the modules/ course content/ facilities suited to your needs?',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Compulsory Questions',
                            questions:
                                'Are they able to list all modules they will study on the course?	',
                            answerType: 'text',
                        },
                    ],
                },
            ],
        },
    ];

    additionalQuestions: any = [
        {
            primary: {
                heading: 'Additional Questions',
                categoryName: 'Additional',
            },

            questionList: [
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question:
                        '5. What are your future plans? and How will studying this course help you achieve this? <br /> 6. What is your expected salary upon your return to your home country?',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Additional Sub Questions',
                            questions:
                                'Future Plans of the applicant - Confirm the plans as the applicant intends to do after she/he completes the course.',
                            answerType: 'textarea',
                        },
                    ],
                },

                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question:
                        '7. What was the last course of study you completed and when?',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Additional Sub Questions',
                            questions:
                                'Last Qualification (Confirm: Title, Year Completed, Any Resits)',
                            answerType: 'textarea',
                        },
                    ],
                },

                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: '8. How did you meet the English requirement',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Additional Sub Questions',
                            questions:
                                'Confirm details of English Language qualifications we have on file.',
                            answerType: 'options',
                            label: 'Confirm details of English',
                            options: [
                                {
                                    label: 'SELT',
                                    value: 'SELT',
                                },

                                {
                                    label: 'English Assessment by University',
                                    value: 'English Assessment by University',
                                },
                                {
                                    label: 'No EA condition in offer',
                                    value: 'No EA condition in offer',
                                },
                            ],
                        },
                    ],
                },

                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question:
                        '9.What have you been doing since? <br /> 10. (if there has been a gap in studies) Why have you chosen to resume your studies?<br /> 11. (if applicant has been working since last course of study) What was your monthly salary?',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Additional Sub Questions',
                            questions: 'Explain any study Gap/Work Experience',
                            answerType: 'textarea',
                        },
                    ],
                },

                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question:
                        '12.How much will the course cost? <br /> 13. Who is funding your studies?',
                    answerType: 'options',
                    subQuestions: [
                        {
                            labelName: 'Additional Sub Questions',
                            questions:
                                'How will the applicant fund their studies?',
                            answerType: 'options',
                            label: 'Fund their studies',
                            options: [
                                {
                                    label: 'SELT',
                                    value: 'SELT',
                                },

                                {
                                    label: 'English Assessment by University',
                                    value: 'English Assessment by University',
                                },
                                {
                                    label: 'No EA condition in offer',
                                    value: 'No EA condition in offer',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ];

    user_details: any;

    constructor(
        private _fb: FormBuilder,
        private _universityService: UniversityService,
        private _authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.user_details = this._authenticationService.getLoginUserDetails();
        this._universityService.submitForms.subscribe((res) => {
            if (res) this.onSubmit();
        });

        this.interviewForm = this._fb.group({
            radioQuestions: this._fb.array([]),
            decisionQuestions: this._fb.array([]),
            compulsoryQuestions: this._fb.array([]),
            additionalQuestions: this._fb.array([]),
        });

        this.initRadioQuestions();
        this.initCompulsoryQuestions();
        this.initAdditionalQuestions();
    }

    initRadioQuestions() {
        const control = this.interviewForm.get('radioQuestions') as FormArray;
        const decisionControl = this.interviewForm.get(
            'decisionQuestions'
        ) as FormArray;
        this.radioQuestionArr.forEach((q) => {
            const group = this._fb.group({
                question: [q.question],
                answer: ['', Validators.required],
                subQuestions: this._fb.array([]),
            });
            control.push(group);
        });
        this.decisionQuestionArr[0]?.questions.forEach((q) => {
            const group = this._fb.group({
                question: [q.question],
                answer: ['', Validators.required],
            });
            decisionControl.push(group);
        });
    }

    onChanges(control: any, index: number = 0): void {
        this.updateSubQuestions(control, index);
    }

    updateSubQuestions(control: FormGroup, index: number = 0) {
        const question = this.radioQuestionArr[index];
        const answer = control.get('answer').value;

        if (question.subQuestions) {
            const subControl = control.get('subQuestions') as FormArray;
            subControl.clear();

            if (question.options) {
                question.subQuestions
                    .filter((item) => item.id === answer)
                    .forEach((subQ) => {
                        const subGroup = this._fb.group({
                            question: [subQ.question],
                            answer: [''],
                        });
                        subControl.push(subGroup);
                    });
            }
        }
    }

    initAdditionalQuestions() {
        const control = <FormArray>(
            this.interviewForm.get('additionalQuestions')
        );
        this.additionalQuestions.forEach((q) => {
            const group = this._fb.group({
                additionalQuestionList: this._fb.array(
                    q.questionList.map((item) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [''],
                            decision: [''],
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    initCompulsoryQuestions() {
        const control = <FormArray>(
            this.interviewForm.get('compulsoryQuestions')
        );
        this.interviewQuestions.forEach((q) => {
            const group = this._fb.group({
                riskScore: this._fb.group({
                    question: [q.riskScore.question],
                    answer: ['0', Validators.required],
                }),
                casRecommended: this._fb.group({
                    question: [q.casRecommended.question],
                    answer: [''],
                }),
                releventInformation: this._fb.group({
                    question: [q.releventInformation.question],
                    answer: [''],
                }),

                questionList: this._fb.array(
                    q.questionList.map((item) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [''],
                            decision: [''],
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    onSubmit() {
        console.log(this.interviewForm?.value);
        const radioData = this.interviewForm?.value?.radioQuestions.map(
            (element, index) => {
                return {
                    labelName: this.radioQuestionArr[index]?.labelName,
                    question: this.radioQuestionArr[index]?.question,
                    answer: element?.answer,
                    answerType: this.radioQuestionArr[index]?.type,
                    asnwerValues: this.radioQuestionArr[index]?.options.map(
                        (item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }
                    ),
                    categoryName: this.radioQuestionArr[index]?.categoryName,
                    optionalFields: [],
                    subQuestions: this.radioQuestionArr[
                        index
                    ]?.subQuestions?.map((item, subIndex) => {
                        return {
                            labelName:
                                this.radioQuestionArr[index]?.subQuestionLabel
                                    ?.label,
                            questions: item?.question,
                            categoryName: item?.categoryName,
                            answer: element.subQuestions[subIndex]?.answer,
                            answerType: item?.type,
                            answerValues: item.options.map((item) => {
                                return {
                                    id: item?.id,
                                    values: item?.label,
                                };
                            }),
                            optionalFields: [],
                        };
                    }),
                };
            }
        );

        const decisionRadioData =
            this.interviewForm?.value?.decisionQuestions.map(
                (element, index) => {
                    return {
                        labelName:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.labelName,
                        question:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.question,
                        answer: element?.answer,
                        answerType:
                            this.decisionQuestionArr[0]?.questions[index]?.type,
                        asnwerValues: this.decisionQuestionArr[0]?.questions[
                            index
                        ].options.map((item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }),
                        categoryName:
                            this.decisionQuestionArr[0]?.questions[index]
                                .categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        const CompulsoryQuestionList =
            this.interviewForm?.value?.compulsoryQuestions[0].questionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.labelName,
                        question:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.question,
                        answer: element?.decision,
                        decision: element?.decision,
                        answerType:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.answerType,
                        answerValues:
                            this.interviewQuestions[0]?.primary?.decisions.map(
                                (item) => {
                                    return {
                                        id: item?.value,
                                        values: item?.value,
                                    };
                                }
                            ),
                        categoryName:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.categoryName,
                        optionalFields: [],
                        subQuestions: [
                            {
                                labelName: `${
                                    this.interviewQuestions[0]?.questionList[
                                        index
                                    ]?.subQuestions[0]?.labelName
                                } ${index++}`,
                                questions:
                                    this.interviewQuestions[0]?.questionList[
                                        index
                                    ]?.subQuestions[0]?.questions,
                                answer: '',
                                answerType:
                                    this.interviewQuestions[0]?.questionList[
                                        index
                                    ]?.subQuestions[0]?.answerType,
                                answerValues: [],
                                optionalFields: [],
                            },
                        ],
                    };
                }
            );

        const additionalQuestions =
            this.interviewForm?.value?.additionalQuestions[0].additionalQuestionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.labelName,
                        question:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.question,
                        answer: element?.answer,
                        decision: element?.decision,
                        answerType:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.answerType,
                        answerValues:
                            this.additionalQuestions[0].questionList[index]
                                .subQuestions[0]?.answerType === 'textarea'
                                ? this.interviewQuestions[0]?.primary?.decisions.map(
                                      (item) => {
                                          return {
                                              id: item?.value,
                                              values: item?.value,
                                          };
                                      }
                                  )
                                : this.additionalQuestions[0].questionList[
                                      index
                                  ].subQuestions[0].options?.map((item) => {
                                      return {
                                          id: item?.value,
                                          values: item?.value,
                                      };
                                  }),
                        categoryName:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.categoryName,
                        optionalFields: [],
                        subQuestions: [
                            {
                                labelName: `${
                                    this.additionalQuestions[0]?.questionList[
                                        index
                                    ]?.subQuestions[0]?.labelName
                                } ${index++}`,
                                questions:
                                    this.additionalQuestions[0]?.questionList[
                                        index
                                    ]?.subQuestions[0]?.questions,
                                answer: '',
                                answerType:
                                    this.additionalQuestions[0]?.questionList[
                                        index
                                    ]?.subQuestions[0]?.answerType,
                                answerValues: [],
                                optionalFields: [],
                            },
                        ],
                    };
                }
            );

        const riskScore = {
            labelName: this.interviewQuestions[0]?.riskScore?.labelName,
            questions: this.interviewQuestions[0]?.riskScore?.question,
            answer: this.interviewForm?.value?.compulsoryQuestions[0]?.riskScore
                ?.answer,
            answerType: this.interviewQuestions[0]?.riskScore?.answerType,
            answerValues: [],
            optionalFields: [],
        };
        const casRecommended = {
            labelName: this.interviewQuestions[0]?.casRecommended.labelName,
            questions: this.interviewQuestions[0]?.casRecommended?.question,
            answer: this.interviewForm?.value?.compulsoryQuestions[0]
                ?.casRecommended?.answer,
            answerType: this.interviewQuestions[0]?.casRecommended?.answerType,
            answerValues:
                this.interviewQuestions[0]?.casRecommended.options.map(
                    (item) => {
                        return {
                            id: item?.value,
                            values: item?.value,
                        };
                    }
                ),
            optionalFields: [],
        };

        const releventInformation = {
            labelName:
                this.interviewQuestions[0]?.releventInformation?.labelName,
            questions:
                this.interviewQuestions[0]?.releventInformation?.question,
            answer: this.interviewForm?.value?.compulsoryQuestions[0]
                ?.releventInformation?.answer,
            answerType:
                this.interviewQuestions[0]?.releventInformation?.answerType,
            answerValues: [],
            optionalFields: [],
        };

        const questions = [
            ...radioData,
            ...CompulsoryQuestionList,
            ...decisionRadioData,
            ...additionalQuestions,
            riskScore,
            casRecommended,
            releventInformation,
        ];

        this.formSubmit.emit({
            questions,
        });
    }
}
